// Neutral "No Image Available" placeholder for hotel cards, gallery tiles,
// and rails. Rendered ONLY when the supplier (Hotelbeds / ETG / etc.) does
// not return an image — never as a stylistic fallback. Important for ETG
// certification and honest representation of supplier data.

import React from 'react';
import { ImageOff } from 'lucide-react';

const NoImagePlaceholder = ({ label = 'No image available', className = '', compact = false }) => (
  <div
    role="img"
    aria-label={label}
    data-testid="no-image-placeholder"
    className={`w-full h-full grid place-items-center bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 ${className}`}
  >
    <div className="flex flex-col items-center gap-1">
      <ImageOff className={compact ? 'h-5 w-5' : 'h-7 w-7 opacity-70'} strokeWidth={1.5} />
      {!compact && <span className="text-[10px] uppercase tracking-widest">{label}</span>}
    </div>
  </div>
);

export default NoImagePlaceholder;
